import { Component } from '@angular/core';

@Component({
  selector: 'cr-avid-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent { }
